import $ from 'jquery';

const sliderGalleryNav = () => {
    // Blocco Slider 2 - slider di navigazione
    $('.gallery-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: false,
        asNavFor: '.gallery-for',
        centerMode: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ],
    });
}

export default sliderGalleryNav;